<template>
  <ContainerScrolling class="communities-dashboard">
    <CommunitiesBanner :banner-title="pageName" :banner-text="bannerText" />

    <LayoutGutters class="mt-6">
      <SelectedCommunities :communities="communities" />
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import CommunitiesBanner from "~/components/banner/CommunitiesBanner.vue";
import SelectedCommunities from "~/components/communities/SelectedCommunities.vue";
import LayoutGutters from "~/components/layout/LayoutGutters.vue";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";
import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";

export default {
  name: "CommunitiesDashboard",
  components: {
    ContainerScrolling,
    CommunitiesBanner,
    LayoutGutters,
    SelectedCommunities,
  },
  data() {
    return {
      pageName: "Communities",
      bannerText:
        "Join in the conversation, discover new ideas, and share your research in one of our interdisciplinary, collaborative community spaces.",
    };
  },
  async fetch(context) {
    const { $config, redirect, $unleash } = context;
    const partner = $config.partner;

    if (!$unleash.isEnabled("quickActionShowCommunities")) {
      return redirect(`/engage/${partner}/public-dashboard`);
    }
    await buildActionDispatcher("loadCommunitiesDashboard")(context);
  },
  head() {
    const { siteName, partner } = this;
    const title = getPageTitle(siteName);
    const pageTitle = this.pageName + " | " + title;
    const canonicalUrl = toCanonicalUrl(`communities-dashboard`, partner);

    return {
      title: pageTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.bannerText,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
      communitySummaries: (state) => state.currentOrigin.communitySummaries,
      siteName: (state) => getSiteName(state.theme),
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    communities() {
      return this.communitySummaries.map((community) => {
        return {
          ...community,
          exploreLink: `/engage/${this.partner}/community-details/${community.id}`,
        };
      });
    },
  },
};
</script>
